import { api, getAuthorizationToken } from 'pages/APIs';
import AbstractApiService from 'src/services/abstractApiService';
import type { dynamicObj } from 'src/pages/assets';

export default class RegexesApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async validatePattern(data: dynamicObj): Promise<any> {
    const formData = new FormData();
    formData.append('patterns', JSON.stringify(data));
    return super.post(api.validate_patterns, formData);
  }
}
